var map = {
	"./ICRU49/Air.txt": 9827,
	"./ICRU49/Lucite.txt": 1853,
	"./ICRU49/Water.txt": 2722,
	"./ICRU91/Air.txt": 5696,
	"./ICRU91/Lucite.txt": 6608,
	"./ICRU91/Water.txt": 6817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9555;